module.exports = __webpack_public_path__ + "static/img/004txt-02.6bbd8a43.png";